<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="moduleForm">
		 <!-- NOME * -->
		<div class="grid">
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Name, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.Name, 'label')">{{ 'NAME' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.Name, 'borderInput')">
					<input type="text" pInputText
						[ngClass]="dynamicInputTextWidth()"
						formControlName="Name"
						autocomplete="module-name"
						placeholder="{{ 'NAME' | translate }}"
						maxlength="48"
					/>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Name)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
	   </div>
	   <!-- FIRMWARE * -->
	   <div class="grid">
			<div class="col-12 text-sm flex justify-content-start align-items-center flex-wrap">
				<div>{{'FWVersion' | translate }}: {{(module.FWVersion) ? (module.FWVersion) : ('NO_TASK_INFO_AVAILABLE' | translate)}}</div>
			</div>
			<div class="col-12 pt-0 text-sm flex justify-content-start align-items-center flex-wrap">
				<div class="">{{'FWVersionBL' | translate }}: {{(module.FWVersionBL) ? (module.FWVersionBL) : ('NO_TASK_INFO_AVAILABLE' | translate)}}</div>
			</div>
		</div>
		<!-- SETTINGS * -->
		<div class="grid">
			<div class="col-12 flex align-items-center justify-content-center text-3xl font-medium">
				{{ 'SETTINGS' | translate }}
			</div>
		</div>

		<div *ngFor="let setting of mtmacConfig; let i=index;">
			<div *ngIf="setting.Value !== null" [class]="onExtendedMobile() ? 'grid mt-1' : 'col-12 flex align-items-center justify-content-between px-0 pb-0' ">
				<ng-container>
					<!-- !! TO CHECK LAYOUT AND FEATURE -->
					<div *ngIf="setting.Type === 'numeric'">
						<div class="flex justify-content-between flex-wrap" >
							<div class="flex align-items-center justify-content-center">{{ 'DEFINE_DELAY_TIME' | translate }} *</div>
							<div class="flex align-items-center justify-content-center">
								<p-inputNumber [formControlName]="setting.Id" step="1" [useGrouping]="false" [maxFractionDigits]="0" [showButtons]="true"
										incrementButtonClass="p-0" decrementButtonClass="p-0 border-noround"
										[max]="setting.Max"
										[min]="setting.Min">
								</p-inputNumber>
							</div>
						</div>
					</div>
					<div *ngIf="setting.Type === 'intset'" class="col-12 px-0" [class]="onExtendedMobile() ? '' : 'pb-0'">
							<div class="flex justify-content-between flex-wrap border-100 border-bottom-1" [ngClass]="dynamicBorderLabelMobile('borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ getTranslate(setting.Name, true) }}</div>
								<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
									<p-dropdown [options]="setting.Values"
										[ngClass]="dynamicInputTextWidth()" appendTo="body"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
										[formControlName]="setting.Name">
										<ng-template pTemplate="selectedItem">
											<div class="item" class="flex align-items-center justify-content-center text-center pl-5">
												<div class="flex align-items-center">{{ (f[setting.Name]) ? getTranslate(f[setting.Name].value.Label, false) : "" }}</div>
											</div>
										</ng-template>
										<ng-template let-controlItem pTemplate="item">
											<div class="item">
												<div>{{ getTranslate(controlItem.Label, false)}}</div>
											</div>
										</ng-template>
									</p-dropdown>
								</div>
							</div>
							<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
							<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
					</div>
					<div *ngIf="setting.Type === 'bool'" class="col-12 px-0" [class]="onExtendedMobile() ? '' : 'pb-0'">
							<div class="flex justify-content-between flex-wrap border-100 border-bottom-1" [ngClass]="dynamicBorderLabelMobile('borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ getTranslate(setting.Name, true) }}</div>
								<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
									<p-dropdown [options]="setting.Values"
										[ngClass]="dynamicInputTextWidth()" appendTo="body"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
										[formControlName]="setting.Name">
										<ng-template pTemplate="selectedItem">
											<div class="item" class="flex align-items-center justify-content-center text-center pl-5">
												<div class="flex align-items-center">{{ (f[setting.Name]) ? getTranslate(f[setting.Name].value.Label, false) : "" }}</div>
											</div>
										</ng-template>
										<ng-template let-controlItem pTemplate="item">
											<div class="item">
												<div>{{ getTranslate(controlItem.Label, false)}}</div>
											</div>
										</ng-template>
									</p-dropdown>
								</div>
							</div>
							<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
							<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
					</div>
					<div *ngIf="setting.Type === 'str'" class="col-12 px-0" [class]="onExtendedMobile() ? '' : 'pb-0'">
							<div class="flex justify-content-between flex-wrap border-100 border-bottom-1" [ngClass]="dynamicBorderLabelMobile('borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ setting.Name }}</div>
								<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
									<input type="text" pInputText
										[ngClass]="dynamicInputTextWidth()"
										[formControlName]="setting.Name"
										placeholder="{{ setting.Name }}"
										maxlength="{{setting.Max}}"
									/>
								</div>
							</div>
							<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
							<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
					</div>
					<div *ngIf="setting.Type === 'tzlist'" class="col-12 pb-0">
							<div class="flex justify-content-between flex-wrap border-100 border-bottom-1" [ngClass]="dynamicBorderLabelMobile('borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ getTranslate(setting.Name, true) }}</div>
								<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
									<p-dropdown [options]="timezones"
										[ngClass]="dynamicInputTextWidth()" appendTo="body"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
										[formControlName]="setting.Name">
										<ng-template pTemplate="selectedItem">
											<div class="item" class="flex align-items-center justify-content-center text-center pl-5">
												<div class="flex align-items-center">{{ (f[setting.Name]) ? f[setting.Name].value : "" }}</div>
											</div>
										</ng-template>
										<ng-template let-controlItem pTemplate="item">
											<div class="item">
												<div>{{ controlItem}}</div>
											</div>
										</ng-template>
									</p-dropdown>
								</div>
							</div>
							<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
							<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
					</div>
				</ng-container>
			</div>
		</div>
	
	   <div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		  <button type="submit" pButton pRipple
				label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1"
				[ngClass]="dynamicButtonWidth()">
		  </button>
		  <button type="button" pButton pRipple (click)="closeDialog()"
				label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1"
				[ngClass]="dynamicButtonWidth()">
		  </button>
	   </div>
	</form>
</div>